import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
}

export const SEO: React.FC<SEOProps> = ({
    title,
    description,
    image,
    url,
    type = 'website'
}) => {
    const siteTitle = 'LivingPP';

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            {title && <title>{title} | {siteTitle}</title>}
            {description && <meta name="description" content={description} />}

            {/* Open Graph / Facebook */}
            {type && <meta property="og:type" content={type} />}
            {url && <meta property="og:url" content={url} />}
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            {url && <meta name="twitter:url" content={url} />}
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}
        </Helmet> 
    );
};
